// extracted by mini-css-extract-plugin
export default {"authentication":"Authe_authentication__6dXYK","authFormWrpper":"Authe_authFormWrpper__XufWh","telegramBtn":"Authe_telegramBtn__lLEAZ"};